import { Pipe, PipeTransform } from '@angular/core';
import { formatCnpj } from '../../@core/utils/cnpj-formatter';

@Pipe({
    name: 'cnpj'
})
export class CnpjPipe implements PipeTransform {
    transform(value: string): string {
        return formatCnpj(value);
    }
}